// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__ZEOsZ","bannerHidden":"Banner_bannerHidden__6J0IW","boxShadowLight":"Banner_boxShadowLight__G0Kx3","bannerClose":"Banner_bannerClose__iSONl"};